import { forwardRef } from 'react';
import { Link as RrdLink, LinkProps as RrdLinkProps } from 'react-router-dom';
import { Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material';

export type RouterLinkProps = Omit<RrdLinkProps, 'instance'> &
  Omit<MuiLinkProps, 'component' | 'href'>;

export const RouterLink = forwardRef<HTMLAnchorElement, RouterLinkProps>((props, ref) => (
  <MuiLink {...props} component={RrdLink} ref={ref} />
));

RouterLink.displayName = 'RouterLink';
